export enum Customer {
    mercedes = 'mercedes',
    gs1 = 'gs1',
}
